"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactTransitionGroup = require("react-transition-group");

var _reactRouterDom = require("react-router-dom");

var _detailView = _interopRequireDefault(require("../detail-view"));

var _search = _interopRequireDefault(require("../search"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AnimationWrapper = function AnimationWrapper(_ref) {
  var location = _ref.location;
  var locationWithoutLocale = location.pathname.split('/').slice(2).join('/');
  document.body.classList.remove('modal');
  var isDetailView = location.pathname.includes('/farm/');
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'animation-wrapper'
  }, /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.TransitionGroup, {
    className: "animation-wrapper__transition-group"
  }, /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.CSSTransition, {
    key: isDetailView ? 'search' : locationWithoutLocale,
    timeout: 500,
    classNames: "animation-wrapper__animate-up",
    unmountOnExit: true
  }, /*#__PURE__*/_react.default.createElement("section", {
    className: "animation-wrapper__route-section"
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, {
    location: location
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: "/:language",
    component: _search.default
  })))), /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.CSSTransition, {
    key: isDetailView ? locationWithoutLocale : 'detail',
    timeout: 500,
    classNames: "animation-wrapper__animate-down",
    unmountOnExit: true
  }, /*#__PURE__*/_react.default.createElement("section", {
    className: "animation-wrapper__route-section"
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, {
    location: location
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "/:language/farm/:pathname/:projectname",
    component: _detailView.default
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: "/:language/farm/:pathname",
    component: _detailView.default
  }))))));
};

AnimationWrapper.propTypes = {
  location: _propTypes.default.shape({
    pathname: _propTypes.default.string,
    projectname: _propTypes.default.string
  })
};

var _default = (0, _reactRouterDom.withRouter)(AnimationWrapper);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/animation-wrapper/index.js
// module id = 606
// module chunks = 0